import script from "./wasabAudio.vue?vue&type=script&setup=true&lang=js"
export * from "./wasabAudio.vue?vue&type=script&setup=true&lang=js"

import "./wasabAudio.vue?vue&type=style&index=0&id=3698c003&lang=css"

const __exports__ = script;

export default __exports__